import * as React from "react";
import { Navigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "./store/hooks";
import { setIsChangingContext, setRedirect } from "./store/contextSlice";

export const Redirect: React.FC = () => {
  // TODO doesnt make sense to be under context
  const redirect = useAppSelector((state) => state.context.redirect);
  const dispatch = useAppDispatch();
  React.useEffect(() => {
    return () => {
      dispatch(setIsChangingContext(false));
      dispatch(setRedirect(null));
    };
  }, []);

  return (
    <div style={{ width: "100vw", height: "100vh", backgroundColor: "var(--color-drop)" }}>
      <Navigate to={redirect || "/"} />
    </div>
  );
};
